module.exports = __webpack_public_path__ + "img/lcs_logo.a64a4220.jpg";